import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametresInstance } from "../../Controls/Parameters";
import { SalarieDto } from "../../../dto/GenApi.iNotPaie.Dto/SalarieDto";
import { SocieteCreationCommandDto } from "../../../dto/GenApi.iNotPaie.Dto/SocieteCreationCommandDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class ModalAjoutSocieteComponent extends Vue {
	public baseId: string = "ModalAjoutSocieteComponent" + Math.random().toString(36).slice(2);

	public code = "";
	public libelle = "";
	public mois: number = (new Date()).getUTCMonth() + 1;
	public annee: number = (new Date()).getUTCFullYear();
	public siretPrecedent?: number;
	public dateChangementSiret?: Date;

	public salaries: SalarieDto[] = [];
	public salariesFiltered: SalarieDto[] = [];
	public isLoading = 0;
	public allSelected = false;
	public orderingDesc = true;
	public currentOrderColumn = "FullName";

	public init(): void {
    	this.isLoading = 0;

    	if (ParametresInstance.societeCourante == undefined || ParametresInstance.societeCourante.Code == undefined) {
			return;
		}

    	this.code = "";
    	this.libelle = "";
    	this.mois = (new Date()).getUTCMonth() + 1;
    	this.annee = (new Date()).getUTCFullYear();

    	this.isLoading++;
    	ServicesFactoryInstance.SalarieService.getSalariesActifs(data => {
    		this.isLoading--;
    		this.salaries = data;
    		this.salariesFiltered = this.salaries;
    		this.allSelected = false;
    		this.doOrder();
    	}, () => this.isLoading--);
	}

	public orderBy(columnName: string): void {
    	if (this.currentOrderColumn == columnName) {
    		this.orderingDesc = !this.orderingDesc;
    	} else {
    		this.orderingDesc = true;
    	}
    	this.currentOrderColumn = columnName;
    	this.doOrder();
	}

	public doOrder(): void {
    	const orderingDesc = this.orderingDesc;
    	const columnName = this.currentOrderColumn;
    	if (this.salariesFiltered != undefined) {
    		this.salariesFiltered.sort(function(a, b) {
    			if (a[columnName] < b[columnName]) {
					return (orderingDesc ? -1 : 1);
				}
    			if (a[columnName] > b[columnName]) {
					return (orderingDesc ? 1 : -1);
				}

    			return 0;
    		});
    	}
	}

	public selectAll(): void {
    	for (let i = 0; i < this.salariesFiltered.length; i++) {
    		const c: any = this.salariesFiltered[i];
    		c.selected = this.allSelected;
    	}
	}

	public isValid(): boolean {
    	if (this.code == undefined || this.code == "") {
    		NotificationServiceInstance.SendFailed("Le code société est obligatoire");

    		return false;
    	}

    	if (this.libelle == undefined || this.libelle == "") {
    		NotificationServiceInstance.SendFailed("Le libellé société est obligatoire");

    		return false;
    	}

    	if (this.annee == undefined) {
    		NotificationServiceInstance.SendFailed("L'année de l'exercice est obligatoire");

    		return false;
    	}

    	if (this.mois == undefined) {
    		NotificationServiceInstance.SendFailed("Le mois de l'exercice est obligatoire");

    		return false;
    	}

    	if (this.siretPrecedent != undefined && isNaN(this.siretPrecedent)) {
    		NotificationServiceInstance.SendFailed("L'ancien SIRET ne doit être composé que de chiffres");

    		return false;
    	}

    	if (!this.salariesFiltered.every(x => (x as any).selected != true) &&
            (this.siretPrecedent == undefined || (this.siretPrecedent as any) == "" ||
                this.dateChangementSiret == undefined || (this.dateChangementSiret as any) == "")) {
    		NotificationServiceInstance.SendFailed("Vous devez renseigner le SIRET précédent et la date de changement lorsque vous effectuez un transfert de société");

    		return false;
    	}

    	if (this.siretPrecedent != undefined && (this.siretPrecedent as any) != "" &&
            (this.dateChangementSiret == undefined || (this.dateChangementSiret as any) == "")) {
    		NotificationServiceInstance.SendFailed("Vous devez renseigner la date de changement lorsque vous renseignez le SIRET précédent");

    		return false;
    	}

    	if ((this.siretPrecedent == undefined || (this.siretPrecedent as any) == "") &&
            this.dateChangementSiret != undefined && (this.dateChangementSiret as any) != "") {
    		NotificationServiceInstance.SendFailed("Vous devez renseigner le SIRET précédent lorsque vous renseignez une date de changement");

    		return false;
    	}

    	return true;
	}

	public annuler(): void {
    	$("#modalAjoutSociete").modal("hide");
	}

	public creer(): void {
    	if (ParametresInstance.societeCourante == undefined || ParametresInstance.societeCourante.Code == undefined) {
			return;
		}

    	if (!this.isValid()) {
			return;
		}

    	const contrats = this.salariesFiltered.filter(x => (x as any).selected && x.NumeroContrat != undefined).map(x => (x.NumeroContrat as number));

    	const command: SocieteCreationCommandDto = {
            CodeSociete: this.code,
    		CodeSocieteADupliquer: ParametresInstance.societeCourante.Code,
    		IdSocieteADupliquer: ParametresInstance.societeCourante.Id,
    		ContratsADupliquer: contrats,
    		Libelle: this.libelle,
    		AnneeExercice: this.annee,
    		MoisExercice: this.mois,
    		SiretPrecedent: this.siretPrecedent,
    		DateChangementSiret: this.dateChangementSiret
    	};
    	ServicesFactoryInstance.SocieteService.create(command, () => {
    		NotificationServiceInstance.SendSuccess("La société a correctement été créée");
    		document.location.reload(true);
    	});
    	$("#modalAjoutSociete").modal("hide");
    	NotificationServiceInstance.SendFailed("Création de la société, merci de ne plus toucher à Talent jusqu'à la fin de l'opération !");
	}
}



// WEBPACK FOOTER //
// ./src/components/ficheSociete/modalAjoutSociete/modalAjoutSociete.ts